import {Injectable} from '@angular/core';
import {LorenPeriod} from '../../interfaces/loren-period.interface';
import {LorenDateUtilsService} from '../../../../services/loren-date-utils-service/loren-date-utils.service';

@Injectable({
    providedIn: 'root'
})
export class LorenPeriodSelectorService {

    static getPeriods(): LorenPeriod[]{
        return [
            {
                label: 'period.yesterday',
                fromDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .subtract(1, 'day').toISOString(),
                toDate: LorenDateUtilsService.getMomentFromDate(new Date()).toISOString(),
                days: 1,
            },
            {
                label: 'period.last_seven_days',
                fromDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .subtract(7, 'day').toISOString(),
                toDate: LorenDateUtilsService.getMomentFromDate(new Date()).toISOString(),
                days: 7,
            },
            {
                label: 'period.last_thirty_days',
                fromDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .subtract(30, 'day').toISOString(),
                toDate: LorenDateUtilsService.getMomentFromDate(new Date()).toISOString(),
                days: 30,
            },
            {
                label: 'period.last_six_months',
                fromDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .subtract(180, 'day').toISOString(),
                toDate: LorenDateUtilsService.getMomentFromDate(new Date()).toISOString(),
                days: 180,
            },
            {
                label: 'period.custom_period',
                fromDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .subtract(1, 'day').toISOString(),
                toDate: LorenDateUtilsService.getMomentFromDate(new Date())
                    .toISOString(),
                isCustomPeriod: true,
                days: null
            }
        ];
    }
}
